export const ETICHETTA_DICHIARANTE: Record<string, string> = {
  licenza_rinnovabili_uso_esente: 'Licenza rinnovabili uso esente',
  licenza_cessione_consumatori_finali: 'Licenza cessione a consumatori finali',
  licenza_altra_officina: 'Licenza altra officina',
  autorizzazione_vendita_consumatore_finale: 'Autorizzazione vendita a consumatore finale',
}
